<template lang="pug">
  .custom-push-container
    section.text
      div {{ text1 }}
      div {{ text2 }}

    section.switch-container()
      .left
        span 启用个性化广告推荐功能
        span 关闭后将不再进行个性化推荐, 实时生效
      .right.flex-mid
        mint-switch(v-model='open', @change='change' class='individualization-switch')
    section.switch-container()
      .left
        span 启用个性化内容推荐功能
        span 关闭后将不再进行个性化推荐, 实时生效
      .right.flex-mid
        mint-switch(v-model='contentOpen', @change='contentChange' class='individualization-switch')
    section.switch-container(v-if="isShowShake")
      .left
        span 允许展现开屏摇一摇广告
        span 如果您对开屏摇一摇广告形式不感兴趣，可以关闭此开关
      .right.flex-mid
        mint-switch(v-model='sensor', @change='shakeChange' class='individualization-switch')

  </template>

<script>
import Toast from '@/components/toast';
import { Switch } from 'mint-ui';
import {
  getCustomPushConfig, setCustomPushConfig, setSwitchExternal, getSwitchExternal,
} from '@/api/custom-push';
import { Native } from '@hb/NBridge/lib/h5';
import { env } from '@hb/hbridge';
import {
  getTokenAndKey, isPreRender, tryCatch,
} from '../../utils';
import { getVersion, getEnv } from '../../utils/systemCode';


const IS_RECOM = 'IS_PERSONALIZED_RECOMMENDATION';
const IS_COMTENT = 'IS_PERSONALIZED_CONTENTOPEN';
const UUID_USED = 'UUID_USED';

export default {
  components: {
    MintSwitch: Switch,
  },
  data() {
    return {
      privacyUUID: false,
      isLogin: false,
      open: false,
      contentOpen: false,
      sensor: true,
      isShowShake: false,
      text1:
          '  为提升您的产品体验，我们会基于如下必要信息向您提供服务的个性化推荐与展示:您在访问或使用哈啰出行客户端时的服务日志，包括浏览记录、点击查看记录、交易信息，以及ip地址、浏览器类型、电信运营商、使用语言、访问日期和时间；您所使用的的设备相关信息，包括设备型号、操作系统版本、设备环境、IDFA、Android OAID、HarmonyOS(OAID)。我们会基于以上信息提取群体的偏好特征，并向相关人群展示或推送可能感兴趣的服务或其他信息，包括在App首页资源位、福利中心、各业务频道内为您提供智能推荐。',
      text2:
          '如果您不想看到我们为您推荐的服务等信息，您可通过以下按钮关闭个性化推荐，帮助您实现对推荐内容的控制与自助决策。',
    };
  },
  async created() {
    // 解决端外设置后app内设置丢失的合规问题
    let uuidOpen = null;
    let uuidContentOpen = null;
    this.open = ((JSON.parse(localStorage.getItem(IS_RECOM))) || {}).openStatus;
    this.contentOpen = ((JSON.parse(localStorage.getItem(IS_COMTENT))) || {}).contentOpenStatus;
    try {
      const { privacyUUID } = this.$route.query;
      this.privacyUUID = privacyUUID;
      if (privacyUUID && env.isAndroid) {
        const param = {
          uniqueId: privacyUUID,
        };
        const res = await getSwitchExternal(param);
        const { contentOpen, open } = res.data;

        if (open) {
          uuidOpen = open === '1';
          localStorage.setItem(UUID_USED, true);
          localStorage.setItem(IS_RECOM, JSON.stringify({
            openStatus: uuidOpen,
          }));
          this.open = uuidOpen;
          await this.change();
          await this.sleep(500);// change是异步接口，需等待
        }
        if (contentOpen) {
          uuidContentOpen = contentOpen === '1';
          this.contentOpen = uuidContentOpen;
          localStorage.setItem(UUID_USED, true);
          localStorage.setItem(IS_COMTENT, JSON.stringify({
            contentOpenStatus: uuidContentOpen,
          }));
        }
      }
    } catch {
      //
    }
    // 版本 >= 6.86.0 且非鸿蒙端才展示开屏摇一摇入口
    this.isShowShake = (await getVersion() >= '6.86.0') && !getEnv().isHarmony;
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    if (localStorage.getItem(IS_RECOM) === null) {
      localStorage.setItem(IS_RECOM, JSON.stringify({ openStatus: true }));
    }

    if (localStorage.getItem(IS_COMTENT) === null) {
      localStorage.setItem(IS_COMTENT, JSON.stringify({ contentOpenStatus: false }));
    }

    this.getData();
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    shouldCallNativeMethod() {
      const ua = window.navigator.userAgent || '';
      return env.isEasyBikeApp && !/OpenHarmony/i.test(ua);// hbridge中暂无鸿蒙标识符，先通过ua判断
    },
    async getData() {
      const { token } = await getTokenAndKey({ needLogin: false });
      // this.contentOpen = (JSON.parse(localStorage.getItem(IS_COMTENT))).contentOpenStatus;
      if (!token) {
        // Toast.show('请先登录');

        // TODO: 跟IOS确认未登录的逻辑
        // this.open = (JSON.parse(localStorage.getItem(IS_RECOM))).openStatus;
        if (this.shouldCallNativeMethod()) {
          try {
            Native.callNative({
              method: 'user_setPersonalizedRecommend',
              classMap: 'business/user',
              params: {
                adRecommendEnable: this.open,
              },
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('[error]====> user_setPersonalizedRecommend', error);
          }
        }

        if (env.isAndroid) {
          // 解决端外设置后app内设置丢失的合规问题 在端外时进入时上传开关状态，防止上次有缓存未上传
          const openParam = {
            uniqueId: this.privacyUUID,
            configType: 'open',
            configValue: this.open ? '1' : '0',
          };
          setSwitchExternal(openParam);

          const contentOpenParam = {
            uniqueId: this.privacyUUID,
            configType: 'contentOpen',
            configValue: this.contentOpen ? '1' : '0',
          };
          setSwitchExternal(contentOpenParam);
        }

        if (env.isEasyBikeApp && env.isIOS) {
          const { open, contentOpen } = await Native.callNative({
            method: 'getPrivacyRightsAuthSwitchInfo',
            classMap: 'business/user',
          }) || {};
          // eslint-disable-next-line no-console
          console.log('[open, contentOpen]====> getPrivacyRightsAuthSwitchInfo', open, contentOpen);
          if (open) {
            this.open = `${open}` === '1';
          }
          if (contentOpen) {
            this.contentOpen = `${contentOpen}` === '1';
          }
        }
        return;
      }
      this.isLogin = true;
      if (env.isEasyBikeApp && env.isIOS) {
        const { open, contentOpen } = await Native.callNative({
          method: 'getPrivacyRightsAuthSwitchInfo',
          classMap: 'business/user',
        }) || {};

        // eslint-disable-next-line no-console
        console.log('[open, contentOpen]====> getPrivacyRightsAuthSwitchInfo', open, contentOpen);
        if (open !== undefined && open !== null) {
          this.open = `${open}` === '1';
        }
        if (contentOpen !== undefined && contentOpen !== null) {
          this.contentOpen = `${contentOpen}` === '1';
        }
      } else {
        try {
          const data = await getCustomPushConfig({
            token,
            configName: 'personalized_recommendation',
          });
          this.open = tryCatch(() => data.data.configValue === 1, false);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('[error]====> getCustomPushConfig', error);
        }
      }
      if (this.shouldCallNativeMethod()) {
        try {
          Native.callNative({
            method: 'user_setPersonalizedRecommend',
            classMap: 'business/user',
            params: {
              adRecommendEnable: this.open,
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('[error]====> user_setPersonalizedRecommend', error);
        }
      }

      if (this.isShowShake) {
        try {
          const isSnake = await Native.callNative({
            method: 'getAdsCacheConfig',
            classMap: 'business/marketing',
            params: {
            },
          }) || {};
          this.sensor = !!isSnake.ads_sensor_status;
        } catch (error) {
        // eslint-disable-next-line no-console
          console.log('[error]====> getAdsCacheConfig', error);
        }
      }
    },
    async change() {
      if (env.isAndroid) {
        // 解决端外设置后app内设置丢失的合规问题
        const param = {
          uniqueId: this.privacyUUID,
          configType: 'open',
          configValue: this.open ? '1' : '0',
        };
        setSwitchExternal(param);
      } else if (env.isEasyBikeApp && env.isIOS) {
        // eslint-disable-next-line no-console
        console.log('[this.open]====> setPrivacyRightsAuthSwithcInfo', this.open);
        Native.callNative({
          method: 'setPrivacyRightsAuthSwithcInfo',
          classMap: 'business/user',
          params: {
            open: this.open ? 1 : 0,
          },
        });
      }
      const { token } = await getTokenAndKey({ needLogin: false });
      if (!token) {
        // localStorage.setItem(IS_RECOM, JSON.stringify({ openStatus: this.open }));
        if (this.shouldCallNativeMethod()) {
          try {
            Native.callNative({
              method: 'user_setPersonalizedRecommend',
              classMap: 'business/user',
              params: {
                adRecommendEnable: this.open,
              },
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('[error]====> user_setPersonalizedRecommend', error);
          }
        }
        return;
      }
      setCustomPushConfig({
        token,
        configName: 'personalized_recommendation',
        configValue: this.open ? 1 : 0,
      })
        .then(() => { })
        .catch((e) => {
          this.open = !this.open;
          Toast.showError(e);
        })
        .finally(() => {
          if (this.shouldCallNativeMethod()) {
            try {
              Native.callNative({
                method: 'user_setPersonalizedRecommend',
                classMap: 'business/user',
                params: {
                  adRecommendEnable: this.open,
                },
              });
            } catch (error) {
              // eslint-disable-next-line no-console
              console.log('[error]====> user_setPersonalizedRecommend', error);
            }
          }
        });
    },
    async contentChange() {
      if (env.isAndroid) {
        const param = {
          uniqueId: this.privacyUUID,
          configType: 'contentOpen',
          configValue: this.contentOpen ? '1' : '0',
        };
        setSwitchExternal(param);
      } else if (env.isEasyBikeApp && env.isIOS) {
        // eslint-disable-next-line no-console
        console.log('[this.contentOpen]====> setPrivacyRightsAuthSwithcInfo', this.contentOpen);
        try {
          Native.callNative({
            method: 'setPrivacyRightsAuthSwithcInfo',
            classMap: 'business/user',
            params: {
              contentOpen: this.contentOpen ? 1 : 0,
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('[error]====> setPrivacyRightsAuthSwithcInfo', error);
        }
      }
      // 调新接口
      localStorage.setItem(IS_COMTENT, JSON.stringify({ contentOpenStatus: this.contentOpen }));
    },

    async shakeChange() {
      if (this.shouldCallNativeMethod()) {
        try {
          Native.callNative({
            method: 'setAdsCacheConfig',
            classMap: 'business/marketing',
            params: {
              ads_sensor_status: this.sensor ? 1 : 0,
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('[error]====> setAdsCacheConfig', error);
        }
      }
    },
  },
};
</script>

<style lang="less">
.custom-push-container {
  height: 100%;
  background-color: #f0f3f5;

  .text {
    padding: 0.16rem 0.16rem;
    font-size: 0.13rem;
    font-weight: 400;
    color: #5a6066;
    line-height: 0.22rem;

    div {
      text-align: justify;
      text-indent: 2em;
    }

    div:nth-of-type(1) {
      margin-bottom: 0.2rem;
    }
  }

  .switch-container {
    display: flex;
    width: 3.51rem;
    justify-content: space-between;
    padding: 0.15rem 0.16rem;
    margin: 0.08rem 0.12rem;
    background: #fff;
    border-radius: 0.08rem;

    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      span:nth-of-type(1) {
        font-size: 0.16rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.22rem;
        margin-bottom: 0.02rem;
      }

      span:nth-of-type(2) {
        max-width: 2.34rem;
        font-size: 0.13rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.18rem;
      }
    }

    .right .individualization-switch {
      .mint-switch-input:checked + .mint-switch-core {
        border-color: #08f;
        background-color: #08f;
      }

      .mint-switch-core::before {
        background-color: #e1e6eb;
      }
    }
  }
}
</style>
